export const observerSection = (
    contentSections: HTMLElement[],
    buttons: HTMLAnchorElement[]
) => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const id: string | null = entry.target.getAttribute("id");
                const buttonActive: HTMLAnchorElement | null =
                    document.querySelector(
                        `.product-anchors ul li a[href="#${id}"]`
                    );

                if (entry.isIntersecting) {
                    buttons.forEach((button: HTMLAnchorElement) =>
                        button.classList.remove("active")
                    );
                    buttonActive?.classList.add("active");
                }
            });
        },
        {
            root: null,
            threshold: 0.8,
        }
    );

    contentSections.forEach((section) => observer.observe(section));
};
